import React from 'react';
import {
  Box,
  InputAdornment,
  InputLabel,
  Typography,
  useTheme,
} from '@mui/material';
import CustomInput from '../../../Main/Components/Custom/CustomInput';

const getFieldSx = (theme) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    bgcolor: 'background.paper',
    fontSize: '13px',
    '& fieldset': { borderColor: theme.palette.divider },
    '&:hover fieldset': { borderColor: theme.palette.text.secondary },
    '&.Mui-focused fieldset': { borderColor: 'primary.main' },
  },
});

const WidgetFormField = ({
  label,
  required,
  icon,
  children,
  inputRef,
  value,
  onChange,
  error,
  helperText,
  type,
  placeholder,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{}}>
      <InputLabel
        required={required}
        sx={{
          fontSize: '12px',
          fontWeight: 700,
          color: 'text.secondary',
          mb: -0.5,
          display: 'block',
        }}
      >
        {label}
      </InputLabel>
      {children || (
        <Box sx={{ position: 'relative', ...getFieldSx(theme) }}>
          <CustomInput
            inputRef={inputRef}
            fullWidth
            small
            value={value}
            onChange={onChange}
            error={error}
            helperText={helperText}
            type={type}
            placeholder={placeholder}
            startIcon={icon}
            InputProps={{
              style: {
                paddingLeft: icon ? 44 : undefined,
                borderRadius: '10px',
                height: type === 'phone_number' ? undefined : '48px',
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default WidgetFormField;
